module.exports = __webpack_public_path__ + "img/boundary-selector.76e8a76c.png";